/**
 * IonLockup — the "BATEMO ION" wordmark (or just "ION", see `short`) with the
 * lightning-bolt mark
 * (IconIonBolt) as a LEADING mark ("⚡ BATEMO ION"). Earlier the bolt replaced
 * the "I" of ION, but a diagonal bolt doesn't read as a vertical "I" (it parsed
 * as "BATEMO ⚡ON"), so the bolt now sits beside a clean Big John wordmark. The
 * bolt is decorative (aria-hidden); the wordmark text carries the name.
 * Set in Big John via the .ion-lockup styles.
 *
 * @param {object} props
 * @param {number} [props.size=28] — font-size (px) of the wordmark; the bolt
 *   scales with it (1.1em).
 * @param {boolean} [props.animated=false] — play the one-shot strike entrance.
 * @param {boolean} [props.short=false] — render just "ION". For the chat
 *   header, where the full name competes with the SNEAK PREVIEW badge and the
 *   controls for a slide-over's width, and where the surrounding product
 *   already establishes whose assistant this is. The accessible name of the
 *   surface is unaffected — IonSurface carries "Batemo Ion assistant".
 * @param {string} [props.className='']
 */
import { IconIonBolt } from '../shared/Icons.jsx'

export function IonLockup({
  size = 28,
  animated = false,
  short = false,
  className = '',
}) {
  return (
    <span
      class={`ion-lockup${className ? ' ' + className : ''}`}
      style={`font-size:${size}px`}
    >
      <span class="ion-lockup__mark" aria-hidden="true">
        <IconIonBolt className="ion-lockup__bolt" animated={animated} />
      </span>
      <span class="ion-lockup__wordmark">{short ? 'ION' : 'BATEMO ION'}</span>
    </span>
  )
}
